import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import BottomNavigation from '@mui/material/BottomNavigation';
import BottomNavigationAction from '@mui/material/BottomNavigationAction';
import Paper from '@mui/material/Paper';
import DashboardIcon from '@mui/icons-material/Dashboard';
import InventoryIcon from '@mui/icons-material/Inventory';
import HistoryIcon from '@mui/icons-material/History';
import SettingsIcon from '@mui/icons-material/Settings';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import { Link as RouterLink, useLocation, useNavigate } from 'react-router-dom';
const navItems = [
    { label: 'Dashboard', path: '/', icon: _jsx(DashboardIcon, {}) },
    { label: 'Inventory', path: '/inventory', icon: _jsx(InventoryIcon, {}) },
    { label: 'History', path: '/refill-history', icon: _jsx(HistoryIcon, {}) },
    { label: 'Settings', path: '/settings', icon: _jsx(SettingsIcon, {}) },
];
export default function Nav() {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
    const location = useLocation();
    const navigate = useNavigate();
    const activeIndex = navItems.findIndex((item) => item.path === location.pathname);
    return (_jsxs(_Fragment, { children: [!isMobile && (_jsx(AppBar, { position: "static", children: _jsxs(Toolbar, { children: [_jsx(Typography, { variant: "h6", sx: { flexGrow: 1 }, children: "Salt Track" }), navItems.slice(0, 3).map((item) => (_jsx(Button, { color: "inherit", component: RouterLink, to: item.path, children: item.label }, item.path))), _jsx(IconButton, { color: "inherit", component: RouterLink, to: "/settings", "aria-label": "Settings", children: _jsx(SettingsIcon, {}) })] }) })), isMobile && (_jsx(Paper, { sx: { position: 'fixed', bottom: 0, left: 0, right: 0, zIndex: theme.zIndex.appBar }, elevation: 3, children: _jsx(BottomNavigation, { showLabels: true, value: activeIndex === -1 ? 0 : activeIndex, onChange: (_event, newValue) => {
                        navigate(navItems[newValue].path);
                    }, children: navItems.map((item) => (_jsx(BottomNavigationAction, { label: item.label, icon: item.icon }, item.path))) }) }))] }));
}
